import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../actions/subscriptions";
import moment from "moment";
import Loader from "react-loader-advanced";
import Divider from "material-ui/Divider";
import Paper from "material-ui/Paper";

import AppFrame from "./Appframe/AppFrame";
import SmallActionButton from "../components/common/SmallActionButton";
import Title from "../components/common/Title";
import Subtitle from "../components/common/Subtitle";
import InfoText from "../components/common/InfoText";
import InfoDialogue from "../components/common/InfoDialogue";
import StripeCheckOut from "./stripe/StripeCheckOut";

import colors, { colorsV2 } from "../styles/colors";
import layout from "../styles/layout";
import config from "../config";
import subPlans from "../config/subscriptionPlans";

import { submitSubscription } from "../services/directcalls";
import Toggle from "material-ui/Toggle";
import { Dialog, DialogContent } from "@material-ui/core";
import { userLogOut } from "../actions/user";

const style = {
  planTitle: {
    color: colorsV2.codGray,
    fontSize: 28,
    marginTop: 60,
  },
  planPrice: {
    color: colorsV2.codGray,
    fontSize: 32,
    marginTop: 40,
    marginBottom: 20,
  },
  planPriceSmall: {
    color: colorsV2.codGray,
    fontSize: 28,
    marginTop: 20,
    marginBottom: 0,
  },
  plans: {
    display: "flex",
    flexDirection: "row",
    marginBottom: 25,
    flex: 1,
  },
  plan_container: {
    display: "flex",
    flexDirection: "column",
    height: 450,
    width: 300,
    margin: 5,
    textAlign: "center",
  },
  plan_title: {
    color: colorsV2.codGray,
    fontSize: 32,
    fontWeight: 500,
    textDecoration: "underline",
    padding: 10,
  },
  plan_title_no_pad: {
    color: colorsV2.codGray,
    fontSize: 32,
    fontWeight: 500,
    textDecoration: "underline",
    padding: 0,
  },
  plan_detailsList: { textAlign: "left" },
  plan_detailItem: {
    fontSize: 16,
    fontWeight: 400,
    padding: 5,
  },
  plan_price: {
    color: colorsV2.codGray,
    fontSize: 24,
    fontWeight: 800,
    padding: 10,
  },
  plan_price_no_pad: {
    color: colorsV2.codGray,
    fontSize: 24,
    fontWeight: 800,
    padding: 0,
    margin: 2,
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    justifyContent: "flex-end",
    alignContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
  buttonRow: {
    display: "flex",
    flexDirection: "row",
  },
};

class AppSubscription extends Component {
  constructor(props) {
    super(props);

    let appId = this.props.match.params.appId;
    let keys = Object.keys(this.props.apps.appInfos);
    if (!keys.includes(appId)) {
      window.location.replace("https://portal.ac-health.com/");
    }

    let appInfo = this.props.apps.appInfos[appId];
    this.state = {
      showDialog: false,
      appId,
      appInfo,
      subData: {},
      trailDaysLeft: 0,
      dialogue: {},
      isProcessingCard: false,
      chosenSubPlan: null,
      yearly: false,
    };

    this.renderChooseSubscriptionPlan =
      this.renderChooseSubscriptionPlan.bind(this);
    this.renderReferralText = this.renderReferralText.bind(this);
    this.renderQuestionsText = this.renderQuestionsText.bind(this);
  }

  componentWillMount() {
    this.props.getSubscriptionData(this.props.userId, this.state.appId);
  }

  componentWillReceiveProps(nextProps) {
    let appInfo = nextProps.apps.appInfos[this.state.appId];
    if (appInfo) {
      this.setState({
        appInfo,
      });
    }
    let subData = nextProps.subscriptions.appsSubData[this.state.appId];
    if (subData) {
      let trailDaysLeft = this.getTrailDaysLeft(subData.publishedTime);
      this.setState({
        subData,
        trailDaysLeft,
      });
    }
  }

  onSubmitSubscription(cardToken, recaptchaValue) {
    this.setState({
      showDialog: false,
      isProcessingCard: true,
    });
    submitSubscription(
      this.props.userId,
      this.state.appId,
      cardToken.id,
      this.state.chosenSubPlan.id,
      this.state.chosenSubPlan.name,
      (ret) => {
        this.setState({
          isProcessingCard: false,
        });
        // refresh subscription data
        this.props.getSubscriptionData(this.props.userId, this.state.appId);
        // pop up dialogue
        this.setState({
          dialogue: {
            title: "We Processed Your Card",
            content: (
              <div
                style={{ color: ret.isSuccessful ? colors.text : colors.error }}
              >
                {ret.message}
              </div>
            ),
          },
        });
        this.refs.infoDialogue.open();
      }
    );
  }

  getTrailDaysLeft(publishedDate) {
    var today = moment(new Date());
    var published = moment(publishedDate, "MMMM Do YYYY, h:mm:ss a");
    var diffDays = today.diff(published, "days");
    let trailDaysLeft = config.system.freeTrailDays - diffDays;
    let validDaysLeft = trailDaysLeft < 0 ? 0 : trailDaysLeft;
    return validDaysLeft;
  }

  getFormatDate(date) {
    return moment(date, "MMMM Do YYYY, h:mm:ss a").format("MMMM, YYYY");
  }

  renderChooseSubscriptionPlan() {
    return (
      <div>
        {!this.state.subData.hasSubscription && (
          <p>Please choose a plan from the below options</p>
        )}

        {!this.state.subData.hasSubscription && (
          <div
            style={{
              display: "flex",
              flexGrow: 1,
              flexDirection: "row",
              padding: 20,
            }}
          >
            <div
              style={{
                flexGrow: 1,
                minWidth: 400,
                fontSize: 18,
                fontWeight: 500,
                paddingRight: 20,
              }}
            >
              Pay Yearly and Get One Month Free!
            </div>
            <Toggle
              size="large"
              checked={this.state.yearly}
              onToggle={() => {
                const toggled = this.state.yearly;
                this.setState({ yearly: !toggled });
              }}
            />
          </div>
        )}
        <div style={style.plans}>
          {this.state.subData.hasSubscription &&
            (this.state.subData.subData.planName ===
              "AC Health - Starting Out (Monthly)" ||
              this.state.subData.subData.planName ===
                "AC Health - Starting Out (Yearly)") && (
              <Paper style={style.plan_container} zDepth={2}>
                <div style={style.plan_title}>Starting Out</div>
                <div style={style.plan_price}>
                  {!this.state.subData.hasSubscription &&
                    (!this.state.yearly
                      ? subPlans.startingout_monthly.price
                      : subPlans.startingout_yearly.price)}

                  {this.state.subData.hasSubscription &&
                    (this.state.subData.subData.planName.includes("Monthly")
                      ? subPlans.startingout_monthly.price
                      : subPlans.startingout_yearly.price)}
                </div>
                <div style={style.plan_userCount}>For 2-5 Active Users</div>
                <div>
                  <ul style={style.plan_detailsList}>
                    <li style={style.plan_detailItem}>
                      App-Only Access for Patients
                    </li>
                    <li style={style.plan_detailItem}>
                      Unlimited Library Content
                    </li>
                    <li style={style.plan_detailItem}>
                      Unlimited Archived Care Plans
                    </li>
                  </ul>
                </div>
              </Paper>
            )}
          {(!this.state.subData.hasSubscription ||
            this.state.subData.subData.planName ===
              "AC Health - Basic (Monthly)" ||
            this.state.subData.subData.planName ===
              "AC Health - Basic (Yearly)") && (
            <Paper style={style.plan_container} zDepth={2}>
              <div style={style.plan_title}>Basic</div>
              <div style={style.plan_price}>
                {!this.state.subData.hasSubscription &&
                  (!this.state.yearly
                    ? subPlans.basic_monthly.price
                    : subPlans.basic_yearly.price)}

                {this.state.subData.hasSubscription &&
                  (this.state.subData.subData.planName.includes("Monthly")
                    ? subPlans.basic_monthly.price
                    : subPlans.basic_yearly.price)}
              </div>
              <div style={style.plan_userCount}>Up to 15 Active Users</div>
              <div>
                <ul style={style.plan_detailsList}>
                  <li style={style.plan_detailItem}>
                    Unlimited Library Content
                  </li>
                  <li style={style.plan_detailItem}>
                    Unlimited Archived Care Plans
                  </li>
                  <li style={style.plan_detailItem}>
                    Online AND App Access For Patients
                  </li>
                  <li style={style.plan_detailItem}>
                    Forever Access for 10 Discharges
                  </li>
                </ul>
              </div>
              <div style={style.buttonContainer}>
                <div style={style.buttonRow}>
                  {!this.state.subData.hasSubscription && (
                    <SmallActionButton
                      label="Choose"
                      onClick={() => {
                        const plan = !this.state.yearly
                          ? subPlans.basic_monthly
                          : subPlans.basic_yearly;
                        this.setState({
                          chosenSubPlan: plan,
                          showDialog: true,
                        });
                      }}
                    />
                  )}
                </div>
              </div>
            </Paper>
          )}
          {(!this.state.subData.hasSubscription ||
            this.state.subData.subData.planName ===
              "AC Health - Professional (Monthly)" ||
            this.state.subData.subData.planName ===
              "AC Health - Professional (Yearly)") && (
            <Paper style={style.plan_container} zDepth={2}>
              <div style={style.plan_title}>Professional</div>
              <div style={style.plan_price}>
                {!this.state.subData.hasSubscription &&
                  (!this.state.yearly
                    ? subPlans.professional_monthly.price
                    : subPlans.professional_yearly.price)}

                {this.state.subData.hasSubscription &&
                  (this.state.subData.subData.planName.includes("Monthly")
                    ? subPlans.professional_monthly.price
                    : subPlans.professional_yearly.price)}
              </div>
              <div style={style.plan_userCount}>For 16-49 Active Users</div>
              <div>
                <ul style={style.plan_detailsList}>
                  <li style={style.plan_detailItem}>
                    Everything from Basic, PLUS:
                  </li>
                  <li style={style.plan_detailItem}>
                    Forever Access for ALL Discharges
                  </li>
                  <li style={style.plan_detailItem}>Printable Care Plans</li>
                </ul>
              </div>
              <div style={style.buttonContainer}>
                {" "}
                <div style={style.buttonRow}>
                  {!this.state.subData.hasSubscription && (
                    <SmallActionButton
                      label="Choose"
                      onClick={() => {
                        const plan = !this.state.yearly
                          ? subPlans.professional_monthly
                          : subPlans.professional_yearly;
                        this.setState({
                          chosenSubPlan: plan,
                          showDialog: true,
                        });
                      }}
                    />
                  )}
                </div>
              </div>
            </Paper>
          )}
          {(!this.state.subData.hasSubscription ||
            this.state.subData.subData.planName ===
              "AC Health - Unlimited (Monthly)" ||
            this.state.subData.subData.planName ===
              "AC Health - Unlimited (Yearly)") && (
            <Paper style={style.plan_container} zDepth={2}>
              <div style={style.plan_title}>Unlimited</div>

              <div style={style.plan_price}>
                {!this.state.subData.hasSubscription &&
                  (!this.state.yearly
                    ? subPlans.unlimited_monthly.price
                    : subPlans.unlimited_yearly.price)}

                {this.state.subData.hasSubscription &&
                  (this.state.subData.subData.planName.includes("Monthly")
                    ? subPlans.unlimited_monthly.price
                    : subPlans.unlimited_yearly.price)}
              </div>
              <div style={style.plan_userCount}>For 50+ Active Users</div>
              <div>
                <ul style={style.plan_detailsList}>
                  <li style={style.plan_detailItem}>
                    Everything from Professional, PLUS:
                  </li>
                  <li style={style.plan_detailItem}>
                    Three-hour Library Video Recording Session
                  </li>
                  <li style={style.plan_detailItem}>
                    Shareable Clinic Libraries
                  </li>
                </ul>
              </div>
              <div style={style.buttonContainer}>
                <div style={style.buttonRow}>
                  {!this.state.subData.hasSubscription && (
                    <SmallActionButton
                      width={150}
                      label="Choose"
                      onClick={() => {
                        const plan = !this.state.yearly
                          ? subPlans.unlimited_monthly
                          : subPlans.unlimited_yearly;
                        this.setState({
                          chosenSubPlan: plan,
                          showDialog: true,
                        });
                      }}
                    />
                  )}
                </div>
              </div>
            </Paper>
          )}
        </div>
        <div style={style.plans}>
          {(!this.state.subData.hasSubscription ||
            this.state.subData.subData.planName ===
              "AC Health - Clinic (Monthly)" ||
            this.state.subData.subData.planName ===
              "AC Health - Clinic (Yearly)") && (
            <Paper style={style.plan_container} zDepth={2}>
              <div style={style.plan_title}>Clinic</div>

              <div style={style.plan_price}>
                {!this.state.subData.hasSubscription &&
                  (!this.state.yearly
                    ? subPlans.clinic_monthly.price
                    : subPlans.clinic_yearly.price)}

                {this.state.subData.hasSubscription &&
                  (this.state.subData.subData.planName.includes("Monthly")
                    ? subPlans.clinic_monthly.price
                    : subPlans.clinic_yearly.price)}
              </div>
              <div style={style.plan_userCount}>For 50+ Active Users</div>
              <div>
                <ul style={style.plan_detailsList}>
                  <li style={style.plan_detailItem}>
                    Everything from Unlimited, PLUS:
                  </li>
                  <li style={style.plan_detailItem}>
                    For up to 3 Providers from the same Clinic
                  </li>
                  <li style={style.plan_detailItem}>
                    Add additional providers for just $10/month
                  </li>
                </ul>
              </div>
              <div style={style.buttonContainer}>
                <div style={style.buttonRow}>
                  {!this.state.subData.hasSubscription && (
                    <SmallActionButton
                      width={150}
                      label="Choose"
                      onClick={() => {
                        const plan = !this.state.yearly
                          ? subPlans.clinic_monthly
                          : subPlans.clinic_yearly;
                        this.setState({
                          chosenSubPlan: plan,
                          showDialog: true,
                        });
                      }}
                    />
                  )}
                </div>
              </div>
            </Paper>
          )}
          {(!this.state.subData.hasSubscription ||
            this.state.subData.subData.planName ===
              "AC Health - Branded App (Monthly)" ||
            this.state.subData.subData.planName ===
              "AC Health - Branded App (Yearly)") && (
            <Paper style={style.plan_container} zDepth={2}>
              <div style={style.plan_title_no_pad}>Branded App</div>
              <div style={style.plan_price_no_pad}>Solo Provider</div>

              <div style={style.plan_price}>
                {!this.state.subData.hasSubscription &&
                  (!this.state.yearly
                    ? subPlans.white_label_individual_monthly.price
                    : subPlans.white_label_individual_yearly.price)}

                {this.state.subData.hasSubscription &&
                  (this.state.subData.subData.planName.includes("Monthly")
                    ? subPlans.white_label_individual_monthly.price
                    : subPlans.white_label_individual_yearly.price)}
              </div>
              <div style={style.plan_userCount}>1 Therapist</div>
              <div>
                <ul style={style.plan_detailsList}>
                  <li style={style.plan_detailItem}>Branded iOS Application</li>
                  <li style={style.plan_detailItem}>
                    Branded Android Application
                  </li>
                  <li style={style.plan_detailItem}>Branded Web Application</li>
                  <li style={style.plan_detailItem}>
                    Unlimited Number of Patients
                  </li>
                </ul>
                *One-Time Development Fee - $300
              </div>
              <div style={style.buttonContainer}>
                <div style={style.buttonRow}>
                  {!this.state.subData.hasSubscription && (
                    <SmallActionButton
                      width={150}
                      label="Choose"
                      onClick={() => {
                        const plan = !this.state.yearly
                          ? subPlans.white_label_individual_monthly
                          : subPlans.white_label_individual_yearly;
                        this.setState({
                          chosenSubPlan: plan,
                          showDialog: true,
                        });
                      }}
                    />
                  )}
                </div>
              </div>
            </Paper>
          )}

          {(!this.state.subData.hasSubscription ||
            this.state.subData.subData.planName ===
              "AC Health - Clinic Branded App (Monthly)" ||
            this.state.subData.subData.planName ===
              "AC Health - Clinic Branded App (Yearly)") && (
            <Paper style={style.plan_container} zDepth={2}>
              <div style={style.plan_title_no_pad}>Branded App</div>
              <div style={style.plan_price_no_pad}>Clinic</div>

              <div style={style.plan_price}>
                {!this.state.subData.hasSubscription &&
                  (!this.state.yearly
                    ? subPlans.white_label_clinic_monthly.price
                    : subPlans.white_label_clinic_yearly.price)}

                {this.state.subData.hasSubscription &&
                  (this.state.subData.subData.planName.includes("Monthly")
                    ? subPlans.white_label_clinic_monthly.price
                    : subPlans.white_label_clinic_yearly.price)}
              </div>
              <div style={style.plan_userCount}>2-6 Therapists</div>
              <div>
                <ul style={style.plan_detailsList}>
                  <li style={style.plan_detailItem}>Branded iOS Application</li>
                  <li style={style.plan_detailItem}>
                    Branded Android Application
                  </li>
                  <li style={style.plan_detailItem}>Branded Web Application</li>
                  <li style={style.plan_detailItem}>
                    Unlimited Number of Patients
                  </li>
                </ul>
                *One-Time Development Fee - $300
              </div>
              <div style={style.buttonContainer}>
                <div style={style.buttonRow}>
                  {!this.state.subData.hasSubscription && (
                    <SmallActionButton
                      width={150}
                      label="Choose"
                      onClick={() => {
                        const plan = !this.state.yearly
                          ? subPlans.white_label_clinic_monthly
                          : subPlans.white_label_clinic_yearly;
                        this.setState({
                          chosenSubPlan: plan,
                          showDialog: true,
                        });
                      }}
                    />
                  )}
                </div>
              </div>
            </Paper>
          )}
        </div>
      </div>
    );
  }

  renderQuestionsText() {
    return (
      <Paper style={{ padding: 10, marginBottom: 20 }}>
        <h3>Questions About Your Subscription?</h3>
        <p>
          Contact us at &nbsp;
          <a href="mailto:info@ac-health.com?subject=I have a question about my subscription">
            info@ac-health.com
          </a>
        </p>
      </Paper>
    );
  }

  renderReferralText() {
    return (
      <Paper style={{ padding: 10 }}>
        <h3>Know a Provider Who Should Check Out AC Health?</h3>
        <p>
          Earn Upgrades, Free Months, Video Swag, and Training Reimbursements
          for referral demos! &nbsp;
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://achealth.outgrow.us/Portal-Refer-AC-Health"
          >
            Refer a colleague now.
          </a>
        </p>
      </Paper>
    );
  }

  render() {
    return (
      <AppFrame
        auth={this.props.auth}
        whiteLabelSettings={this.props.whiteLabelSettings}
      >
        <div style={layout.common.page}>
          <Loader
            show={this.props.subscriptions.isLoading}
            message={"Loading..."}
          >
            <Loader
              show={this.state.isProcessingCard}
              message={"Processing Card..."}
            >
              <Title
                text1="Channel"
                text2="Subscription"
                goBack={() => this.props.history.goBack()}
              />
              <div style={layout.common.detailsContainer}>
                {" "}
                {this.state.appInfo && (
                  <Subtitle text={this.state.appInfo.appName} />
                )}
                <InfoText label="Channel Code:" value={this.state.appId} />
                {this.state.subData.hasSubscription && (
                  <div>
                    <InfoText
                      label="Subscription Started On:"
                      value={this.getFormatDate(
                        this.state.subData.subStartedTime
                      )}
                    />
                    <InfoText
                      label="Your Subscription Plan Is:"
                      value={
                        this.state.subData.subData
                          ? this.state.subData.subData.planName
                          : ""
                      }
                    />
                    <p>
                      Subscription plans are subject to change based on monthly
                      usage. You will receive notification via email prior to
                      any changes in plans or pricing.
                    </p>
                  </div>
                )}
                <br />
                {this.renderChooseSubscriptionPlan()}
                {this.renderQuestionsText()}
                {this.renderReferralText()}
                <Dialog
                  open={this.state.showDialog}
                  onClose={() => {
                    this.setState({ showDialog: false });
                  }}
                >
                  <DialogContent>
                    <h1>
                      {this.state.chosenSubPlan
                        ? this.state.chosenSubPlan.name +
                          " -- " +
                          this.state.chosenSubPlan.price
                        : ""}
                    </h1>
                    <StripeCheckOut
                      onSubmit={(token, recaptchaValue) =>
                        this.onSubmitSubscription(token, recaptchaValue)
                      }
                    />
                  </DialogContent>
                </Dialog>
                <InfoDialogue
                  ref="infoDialogue"
                  title={this.state.dialogue.title}
                  content={this.state.dialogue.content}
                />
              </div>
            </Loader>
          </Loader>
        </div>
      </AppFrame>
    );
  }
}

function mapStateToProps({ user, apps, subscriptions, whiteLabelSettings }) {
  return {
    userId: user.userId,
    apps,
    subscriptions,
    whiteLabelSettings,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AppSubscription);



// WEBPACK FOOTER //
// ./src/layout/AppSubscription.js